<template>
  <div class="panel-content guest">
    <div
      v-for="(guest, i) in guestsLists"
      :key="guest.guestId"
      class="guest-container"
    >
      <dl ref="guestItem" class="guest-item">
        <dt class="guest-avatar">
          <van-image :src="guest.headImgUrl || avatarDef"></van-image>
        </dt>
        <dd class="guest-info">
          <div>{{ guest.name }}</div>
          <div ref="position" class="position">
            {{ guest.enterprise }} {{ guest.duty }}
          </div>
          <div class="intro">
            {{ guest.intro }}
          </div>
        </dd>
      </dl>
      <div v-if="hasFoldList[i]" class="fold-container">
        <span
          class="icon icontemp"
          @click="toggleFold(i, $event)"
          :class="{ down: !noMaxList[i], up: noMaxList[i] }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water";

export default {
  name: "GuestInfo",
  data() {
    return {
      clientHeightList: [],
      hasFold: false, // 是否可折叠
      hasFoldList: [],
      noMax: false, // 是否可折叠
      noMaxList: [],
      guestsLists: [],
      avatarDef: require("../../assets/images/guest-def.jpg") // 嘉宾头像缺省图片地址
    };
  },
  props: {},
  methods: {
    // 切换折叠状态
    toggleFold(i, event) {
      this.noMaxList[i] = !this.noMaxList[i];
      const guestItem = this.$refs.guestItem[i];
      const position = this.$refs.position[i];
      let dom = event.target;
      if (this.noMaxList[i]) {
        dom.classList.remove("down");
        dom.classList.add("up");
      } else {
        dom.classList.remove("up");
        dom.classList.add("down");
      }

      if (this.clientHeightList[i] == "") {
        this.clientHeightList[i] = guestItem.clientHeight + "px";
      }
      if (this.noMaxList[i]) {
        guestItem.style.maxHeight = guestItem.scrollHeight + 95 + "px";
        position.style.webkitLineClamp = 6;
      } else {
        guestItem.style.maxHeight = this.clientHeightList[i];
        position.style.webkitLineClamp = 2;
        position.style;
      }
    },
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        let arr = [];

        if (data.guestList) {
          console.log("dataguestsLists", data.guestList);
          data.guestList.forEach(list => {
            list.showMore = false;
            list.showMoreStatus = false;
            arr.push(list);
          });
          this.guestsLists = arr;
          this.isShowMore();
        }
      });
      $subscriber.subscribe("showGuestLists", data => {
        console.log(data);
        if (this.guestsLists.length > 0) {
          this.isShowMore();
        }
      });
    },
    isShowMore() {
      const self = this;
      self.hasFoldList = [];
      setTimeout(() => {
        const guestItem = self.$refs.guestItem;

        if (guestItem && guestItem.length > 0) {
          for (let i in guestItem) {
            self.hasFoldList.push(
              guestItem[i].scrollHeight > guestItem[i].clientHeight
            );
            self.noMaxList.push(false);
            self.clientHeightList.push("");
          }
        }
      }, 300);
    }
  },
  mounted() {
    this.init();
  },
  created() {}
};
</script>
